/**
 * @generated SignedSource<<5a7bb06770f2b343c8473e42d15fcb56>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ByLineContributors_contentContributors$data = {
  readonly count: number | null;
  readonly isCurrentUserContributor: boolean | null;
  readonly isOwnerContributor: boolean | null;
  readonly nodes: ReadonlyArray<{
    readonly accountId?: string | null;
    readonly displayName: string | null;
    readonly profilePicture: {
      readonly path: string;
    } | null;
    readonly type: string | null;
  } | null> | null;
  readonly " $fragmentType": "ByLineContributors_contentContributors";
};
export type ByLineContributors_contentContributors$key = {
  readonly " $data"?: ByLineContributors_contentContributors$data;
  readonly " $fragmentSpreads": FragmentRefs<"ByLineContributors_contentContributors">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ByLineContributors_contentContributors",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "count"
    },
    {
      "kind": "ScalarField",
      "name": "isCurrentUserContributor"
    },
    {
      "kind": "ScalarField",
      "name": "isOwnerContributor"
    },
    {
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "displayName"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountId"
            }
          ],
          "type": "KnownUser"
        },
        {
          "concreteType": "Icon",
          "kind": "LinkedField",
          "name": "profilePicture",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "path"
            }
          ]
        }
      ]
    }
  ],
  "type": "ContentContributors"
};

(node as any).hash = "779053a535fff2e4b879239a0c659d33";

export default node;
